module.exports = __webpack_public_path__ + "static/media/hr_doc4.2338abed.JPG";